import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    active: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected,
        fontWeight: 700,
    },
    inactive: {
        fontSize: "1rem",
        marginTop: "10px"
    }
}));

export { useStyles };